import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Products = () => {
  const [activeTab, setActiveTab] = useState('Aracınız');
  
  const products = {
    Aracınız: [
      { title: 'Trafik Sigortası', icon: '🚗', link: '/trafik-sigortasi' },
      { title: 'Kasko', icon: '🛡️', link: '/kasko' },
      { title: 'Yol Yardım', icon: '🚨', link: '/yol-yardim-sigortasi', comingSoon: true },
      { title: 'İhtiyari Mali Mesuliyet (İMM)', icon: '💰', link: '/imm-sigortasi', comingSoon: true }
    ],
    Eviniz: [
      { title: 'DASK', icon: '🏘️', link: '/dask', comingSoon: true },
      { title: 'Konut Sigortası', icon: '🏠', link: '/konut-sigortasi', comingSoon: true }
    ],
    Sağlığınız: [
      { title: 'Tamamlayıcı Sağlık Sigortası', icon: '👨‍⚕️', link: '/tamamlayici-saglik-sigortasi' },
      { title: 'Özel Sağlık Sigortası', icon: '🏥', link: '/ozel-saglik-sigortasi', comingSoon: true },
      { title: 'Yabancı Sağlık Sigortası', icon: '🌍', link: '/yabanci-saglik-sigortasi', comingSoon: true },
      { title: 'Seyahat Sağlık Sigortası', icon: '✈️', link: '/seyahat-saglik-sigortasi', comingSoon: true },
      { title: 'Ferdi Kaza', icon: '🚨', link: '/ferdi-kaza' }
    ],
    İşiniz: [
      { title: 'İşyeri Sigortası', icon: '🏢', link: '/isyeri-sigortasi', comingSoon: true },
      { title: 'İnşaat All Risk Sigortası', icon: '🏗️', link: '/insaat-all-risk-sigortasi', comingSoon: true },
      { title: 'Nakliyat Sigortası', icon: '🚛', link: '/nakliyat-sigortasi', comingSoon: true }
    ]
  };

  const navigate = useNavigate(); // useNavigate hook'unu import edin

  const handleProductClick = (product) => {
    if (!product.comingSoon) {
      navigate(product.link);
    }
  };

  return (
    <section className="py-8 md:py-16 bg-gradient-to-r from-blue-50 to-purple-50">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 md:mb-12 text-center">
          Sigorta <span className="text-blue-500">Ürünleri</span>
        </h2>

        <div className="flex flex-wrap justify-center mb-8 gap-2 md:gap-4">
          {Object.keys(products).map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`px-4 md:px-6 py-2 rounded-full text-sm md:text-base transition-all duration-300 ${
                activeTab === tab
                  ? 'bg-blue-500 text-white shadow-md'
                  : 'text-gray-600 hover:bg-blue-50'
              }`}
            >
              {tab}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
          {products[activeTab].map((product, index) => (
            <button
              key={index}
              onClick={() => handleProductClick(product)}
              className={`bg-white rounded-lg p-4 md:p-6 shadow-md transition-all duration-300 
                group cursor-pointer border border-transparent hover:border-blue-200 text-left w-full
                ${product.comingSoon ? 'opacity-50 cursor-default' : 'hover:shadow-xl'}`}
            >
              <div className="flex items-start">
                <div className="flex-1">
                  <div className="text-3xl md:text-4xl mb-4 group-hover:scale-110 transition-transform">
                    {product.icon}
                  </div>
                  <h3 className="text-lg md:text-xl font-semibold text-gray-800 group-hover:text-blue-500 transition-colors">
                    {product.title}
                  </h3>
                  {product.comingSoon && (
                    <span className="inline-block text-xs font-medium text-blue-500 bg-blue-50 px-2 py-0.5 rounded mt-2">
                      Yakında
                    </span>
                  )}
                </div>
                {!product.comingSoon && (
                  <div className="text-blue-500 opacity-0 group-hover:opacity-100 transition-opacity">
                    →
                  </div>
                )}
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;